let todo = {
  title: "My To-do",
  columns: {
    toDoItems: "To-do items",
    emergency: "Emergency",
    taskContent: "Task content",
    taskState:"Task status",
    taskStateText:'Pending',
    taskStateTextEnd:'Processed',
    taskInitiator: "Task initiator",
    taskSendingTime: "Task launch time",
    action: "operation",
    actionText:"To handle"
  },
  details:{
    todoDetails:"To-do details",
    toDoItems: "To-do items",
    taskState:"Task status",
    taskInitiator: "Task initiator",
    taskSendingTime: "Task launch time",
  },
  tabItem:{
    item1:'To-do message',
    item2:'Processed message',
  }

}

export default todo
